import React from 'react'
import {BoxBackground, CustomHeader2, CustomP, CustomP2White, Section} from "../components/Headers"
import {Typography} from "antd"
import {useIsMobile} from "../components/LayoutWrapper"
import TrackerDemo from '../icons/tracker.png'

const {Title} = Typography

const TrackerHeader: React.FC = () => {
    const isMobile = useIsMobile()

    return (
        <BoxBackground
            style={{
                height: 'auto',
                marginBottom: '10vh'
            }}
        >
            <Title
                style={{
                    marginTop: '100px',
                    textAlign: 'center'
                }}
            >
                Visualize Game Data on a Timeline
            </Title>
            <CustomP
                style={{
                    marginLeft: isMobile ? undefined : '10vh',
                    marginRight: isMobile ? undefined : '10vh',
                    textAlign: 'center'
                }}
            >
                Track key moments and stats throughout the game.
            </CustomP>
        </BoxBackground>
    )
}

const TrackerSection: React.FC = () => {
    const isMobile = useIsMobile()
    return (
        <Section>
            <div
                style={{
                    marginLeft: isMobile ? '0vh' : '5vh',
                    marginRight: isMobile ? '0vh' : '10vh'
                }}
            >
                <CustomHeader2>
                    Tracker
                </CustomHeader2>
                <CustomP2White>
                    Explore detailed football performance metrics. Spaik provides in-depth analysis to enhance your
                    understanding of the game.
                    <br/><br/>


                    <img
                        style={{
                            width: isMobile ?'90%':'60%'
                        }}
                        src={TrackerDemo}
                    />

                </CustomP2White>
            </div>
        </Section>
    )
}


const Tracker: React.FC = () => {
    return (
        <div>
            <TrackerHeader/>
            <TrackerSection/>
        </div>
    )
}

export default Tracker